import { SyntheticEvent } from 'react';
import { SwitchStatus } from '..';
import { TableRow } from '../Table/types';

type ToggleColumnProps<T> = {
  onChange: (checked: boolean, row: T) => void;
  value: boolean;
  row: T;
  disabled?: boolean;
};

export const ToggleColumn = <T extends TableRow>({
  onChange,
  value,
  row,
  disabled,
}: ToggleColumnProps<T>) => {
  const handleToggleChange = (
    checked: boolean,
    event: MouseEvent | SyntheticEvent<MouseEvent | KeyboardEvent>,
  ) => {
    event.preventDefault();
    event.stopPropagation();
    onChange(checked, row);
  };
  return (
    <div className="flex items-center gap-2">
      <SwitchStatus
        checked={value}
        onChange={handleToggleChange}
        disabled={disabled}
      />
    </div>
  );
};
